import d from "classnames";
import a, { forwardRef as H, useState as r, useCallback as _, useEffect as m } from "react";
import { IconElement as k } from "../icon-element/icon-element.esm.js";
import { TypographyComponent as M } from "../typography/typography-component.esm.js";
import { ScreenReaderOnly as A } from "../utils/sr-only.esm.js";
import { componentConfig as b } from "./config.esm.js";
const B = "_save_myuqq_1 _tappableArea_1kc19_1 _outline--onFocus_1oe4d_1", I = "_save__icon_myuqq_19", O = "_save__label_myuqq_48", i = {
  save: B,
  save__icon: I,
  save__label: O
}, h = H(
  ({
    onClick: l,
    dataTestId: y,
    saveLabel: g,
    savedLabel: S,
    showLabel: v,
    isSaved: n = !1,
    iconSize: E = b.icon.sizes[1],
    className: q,
    ...x
  }, c) => {
    const { label: t } = b, [e, f] = r(n), [s, u] = r(!1), [T, p] = r(""), o = e ? e && (S || "Saved") : !e && (g || "Save for later"), N = v ? "" : o, R = _(
      (L) => {
        typeof l == "function" && l(L, c, !e), f((C) => !C);
      },
      [e, l, c]
    ), z = _(() => u(!0), []), F = _(() => u(!1), []);
    return m(() => {
      s && p(o);
    }, [o, s]), m(() => {
      s || p("");
    }, [s]), m(() => {
      f(n);
    }, [n]), /* @__PURE__ */ a.createElement(a.Fragment, null, /* @__PURE__ */ a.createElement(
      "button",
      {
        "data-testid": y,
        onClick: R,
        "aria-pressed": e,
        ref: c,
        onFocus: z,
        onBlur: F,
        ...x,
        className: d(i.save, "fuse-save", q)
      },
      /* @__PURE__ */ a.createElement(k, { className: i.save__icon, responsiveSize: E, srLabel: N }),
      v && /* @__PURE__ */ a.createElement(
        M,
        {
          className: d(i.save__label, "fuse-save__label"),
          color: t.color,
          size: t.size,
          tag: t.tag,
          type: t.type,
          disableMargin: !0
        },
        o
      )
    ), s && /* @__PURE__ */ a.createElement(A, { "aria-live": "polite" }, T));
  }
);
h.displayName = "Save";
export {
  h as Save
};
